import Head from "next/head"
import React from "react"
import styled, { css } from "styled-components"

import Typography from "~/components/atoms/Typography"
import { Container } from "~/components/layouts/Container"
import Breadcrumb from "~/components/organisms/Breadcrumb"
import Footer from "~/components/organisms/Footer"
import Header from "~/components/organisms/Header"
import { IsPC, IsMobile, LineHeight } from "~/consts/style-mixins"
import { internalLink, staticPath } from "~/services/helper"

export default class InternshipGuaranteePolicy extends React.Component {
  render() {
    const crumbs = [
      {
        name: "プログラミング講座",
        link: internalLink(`/courses/web-programming`),
      },
      {
        name: "インターン参加保証規約",
        link: internalLink(`/internship-guarantee-conditions`),
      },
    ]

    return (
      <>
        <Head>
          <title>プログラミング講座修了後のインターン参加保証規約 | Infra</title>
          <meta name="description" content="プログラミング講座修了後のインターン参加保証規約です。" />
          <meta property="og:title" content="プログラミング講座修了後のインターン参加保証規約 | Infra" />
          <meta property="og:description" content="プログラミング講座修了後のインターン参加保証規約です。" />
          <meta property="og:image" content={`${process.env.APP_HOST + staticPath("/static/images/ogp.png")}`} />
        </Head>
        <Header logoType="Courses" />
        <StyledContainerWrapper>
          <Container size="Medium">
            <Typography type="SubHero">プログラミング講座修了後のインターン参加保証規約</Typography>
            <StyledContentWrapper>
              <p>
                この規約（以下「本規約」といいます。）は、株式会社Legaseed（以下「当社」といいます。）が提供する「Infraプログラミング講座」を修了した学生（以下「ユーザー」といいます。）のインターンシップ参加保証に関して、ユーザーに同意していただく必要のある事柄を記載しています。ユーザーが本サービスをご利用になる際には、本規約が適用されます。なお、本規約については、ユーザーが受講申込みをした時点で同意されたものとします。
              </p>
              <br />
              <p>
                以下の全ての条件を満たしたユーザーに対してのみ、インターンシップ参加保証が適用されるものとします。なお、本保証は本サービス終了から3ヶ月間のみ有効とします。
              </p>
              <br />
              <ol>
                <li className="list">（1）平日9:00〜21:00で週15時間以上インターンシップへの勤務が可能であること。</li>
                <li className="list">（2）都内のインターンシップに出社勤務が可能であること</li>
                <li className="list">
                  （3）当社からユーザーに対して行う連絡に対する回答や必要書類の提出など、必要な手続き全てに当社が定める期限内にご対応頂くこと。
                </li>
                <li className="list">
                  （4）当社が定める期限内に学習・課題提出およびテストの合格が全て完了していること。
                </li>
                <li className="list">（5）当社が参加を求めた各種イベントや面談に全て出席していること。</li>
                <li className="list">
                  （6）当社またはメンターとの面談予定に事前連絡なく遅刻または欠席した回数が1回以下であること。
                </li>
                <li className="list">
                  （7）当社またはメンターからの回答を求めるチャットに対して36時間以上返信がなかった回数が1回以下であること。
                </li>
                <li className="list">（8）当社もしくは当社が紹介するインターンシップの選考や内定を辞退しないこと。</li>
              </ol>
            </StyledContentWrapper>
          </Container>
        </StyledContainerWrapper>
        <Breadcrumb crumbs={crumbs} />
        <Footer />
      </>
    )
  }
}

const StyledContainerWrapper = styled.div`
  ${IsPC(css`
    padding: 48px 0;
  `)}
  ${IsMobile(css`
    padding: 24px 0 32px;
  `)}
`
const StyledContentWrapper = styled.div`
  margin: 16px 0 32px;
  line-height: ${LineHeight.S}%;
  .list {
    margin-bottom: 8px;
  }
`
